import { useRef } from 'react'

import type { AppBarStickyTriggerElement } from './appbar-sticky-trigger'
import { AppBarContext } from './context'

export type AppBarProviderMode = 'sticky' | 'fixed'

export type AppBarProviderProps = {
  mode?: AppBarProviderMode
  children: React.ReactNode
}

function AppBarProvider(props: AppBarProviderProps) {
  const { mode = 'sticky' } = props
  const stickyTriggerRef = useRef<AppBarStickyTriggerElement>(null)
  return (
    <AppBarContext.Provider value={{ mode, stickyTriggerRef }}>
      {props.children}
    </AppBarContext.Provider>
  )
}

export default AppBarProvider
